(function () {

  'use strict';

  angular.module('eclipseApp.cfa').controller('cfaLandingCtrl', ['$scope', '$timeout', '$state', '$stateParams', 'util', 'notifierService', 'commonService', '$translate', '$rootScope', function ($scope, $timeout, $state, $stateParams, util, notifierService, commonService, $translate, $rootScope) {

    //$scope.message = 'CFA Landing';
    //$scope.messageDetail = 'Redirecting you now...';
    $translate('retail.label.landing').then(function (message) {
      $scope.message = message;
    });
    $translate('retail.message.landing').then(function (messageDetail) {
      $scope.messageDetail = messageDetail;
    });
    $scope.showLoader = true;


    // make blank call to get session information; start session; and route user
    util.startAgentSession().then(function(resolved){
      route(resolved.cfaInfo.targetURL);
    }, function(rejected){
      $scope.message = '';
      $scope.messageDetail = '';
      $scope.showLoader = false;
      notifierService.notify('technical', '');
    });

    // depending on ssp-configured key names, route the user to the appropriate state
    function route(target){
      target = target ? target.toLowerCase() : null;

      $timeout(function(){
        switch(target){
          case 'fhsi':
            $state.go('internet');
            break;
          case 'fiptv':
            $state.go('tv');
            break;
          case 'foverview':
            $state.go('myAccount');
            break;
          default:
            $state.go('home');
        }

        
        // check if transition happened
        $timeout(function () {
          didTransition({state:target});
        }, 5000);

      }, 3000);

    }


    function didTransition (args) {
      var _keys = {
        fhsi : 'internet',
        fiptv: 'tv',
        foverview: 'myAccount',
        'default': 'home'
      };
      var _args = args || {};
      var _states = $state.get();
      var _toState = _.chain(_states)
            .filter(function (v) {
              return v.name === _keys[_args.state];
            })
            .first()
            .value();

      if (_.isObject(_toState) && _toState.name !== '' && $state.current.name !== _toState.name) {
        $state.go(_toState.name);
      } 

    }

  }]);

})();
